<template>
    <PopupOverlay
        ref="popup"
        :whitelist="['marking-area', 'moveable-control', 'document-discussion-modal', 'flash-message']"
        @close="closeCreatePopup"
    >
        <PostCreateForm
            ref="form"
            :show-buttons-label="showButtonsLabel"
            :context-type="contextType"
            :context-id="contextId"
            v-bind="$attrs"
        />

        <template #mobile>
            <PostCreateFormMobile
                v-if="isLoggedIn"
                :context-type="contextType"
                :context-id="contextId"
                v-bind="$attrs"
            />
        </template>
    </PopupOverlay>
</template>

<script>
import PopupOverlay from '@components/PopupOverlay';
import { mapGetters } from 'vuex';
import { useTranslation } from 'i18next-vue';
import PostCreateForm from './PostCreateForm.vue';
import PostCreateFormMobile from './PostCreateFormMobile.vue';

export default {
    name: 'PostCreate',
    components: { PostCreateFormMobile, PostCreateForm, PopupOverlay },
    inheritAttrs: false,
    props: {
        contextId: {
            type: Number,
            required: true,
        },
        contextType: {
            type: String,
            required: true,
            validator(value) {
                return ['course', 'document', 'group'].indexOf(value) !== -1;
            },
        },
        showButtonsLabel: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const { t } = useTranslation('post');
        return { t };
    },
    computed: {
        ...mapGetters('post', ['createPopupIsOpen']),
        ...mapGetters('auth', ['isLoggedIn']),
    },
    watch: {
        createPopupIsOpen(value) {
            if (value) {
                this.$refs.popup.open();
            } else {
                this.$refs.popup.close();
                this.$refs.form.resizeTextarea();
            }
        },
    },
    methods: {
        closeCreatePopup() {
            this.$store.dispatch('post/closeCreatePopup');
        },
        /* called externally */
        trigger() {
            this.$refs.form.$refs.text.focus();
            this.$refs.form.$refs.text.click();
        },
    },
};
</script>
